import { copy } from '../content/copy';
import { LButton } from '../components/LButton';

export function CtaStrip() {
  const { ctaStrip } = copy;
  return (
    <section className="bg-l-ink-deep text-l-paper px-6 md:px-10 py-20 md:py-24">
      <div className="mx-auto max-w-[820px] text-center">
        <h2 className="font-display font-medium text-[30px] md:text-[40px] leading-[1.15] tracking-[-0.02em] mb-4">
          {ctaStrip.title}
        </h2>
        <p className="font-sans text-l-paper/75 text-[16px] md:text-[17px] leading-[1.6] max-w-[520px] mx-auto mb-8">
          {ctaStrip.subtitle}
        </p>
        <LButton href="#contact" variant="primary" className="h-12 px-7 text-[15px]">
          {ctaStrip.cta}
        </LButton>
      </div>
    </section>
  );
}
